import { keyframes, mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useMemo } from "react";

const classNames = {
  toolbar: `Toolbar`
};

const spin = keyframes({
  "0%": {
    transform: `rotate(0deg)`
  },
  "100%": {
    transform: `rotate(359deg)`
  }
});

export const DURATION_MS = 2000;

export function useToolbarStyles(isLoading = false) {
  return useMemo(
    () => mergeStyleSets({
      toolbar: [
        classNames.toolbar,
        {
          width: `100%`,
          "& .ms-CommandBar-primaryCommand": {
            justifyContent: `end`
          },
          ...(isLoading
            ? {
              "& .toolbar-refresh-icon": {
                animationName: spin,
                animationDuration: `${DURATION_MS / 1000}s`,
                animationIterationCount: `infinite`
              }
            }
            : {})
        }
      ]
    }),
    [isLoading]
  );
}
